import { Box, Container, Stack } from '@mui/material';
import { amplitude } from 'wisestep-api';
import {
  CardVariant,
  IUserDTO,
  WsCard,
  WsIconJDParse,
  WsTypoColors,
  WsTypography,
  WsTypoVariants,
} from 'wisestep-base';

import { useUserContext } from '../../../../../src/context';
import { useWorkspaceContext } from '../../../../context/WorkspaceContext';

interface IJobPostingChoiceProps {
  onChoiceSelection: (value: string) => void;
}

const JobPostingChoice = ({ onChoiceSelection }: IJobPostingChoiceProps) => {
  const loggedInUser = useUserContext().userDTO as IUserDTO;
  const workspaceContext = useWorkspaceContext();
  const allowedEmails = [
    'karishma.m@avanceservices.us',
    'ravula.sai@avanceservices.us',
    'saiteja.k@avanceservices.com',
    'deepak.k@avanceservices.com',
    'manikanta.n@avanceservices.com',
    'john.smith@avanceservices.us',
    'akhil.bharadwaj@wisestep-inc.com',
    'ambica.n@avanceservices.com',
  ];

  const booleanAmplitudeEvents = (name: string, clickedOnName: string) =>
    amplitude(name, {
      clickedOn: clickedOnName,
      workspaceName: workspaceContext.name,
      pageName: 'New Job',
      planType: workspaceContext.planType,
      interfaceType: 'web',
      pageUrl: window.location.href,
      userId: loggedInUser.email,
      eventType: 'Generate_JD_Initiate',
    });

  return (
    <Container style={{ marginTop: '7%', width: '100%', marginBottom: '3%' }}>
      <Box textAlign="center">
        <WsTypography variant={WsTypoVariants.TITLE} color={WsTypoColors.PRIMARY900}>
          Post a new job
        </WsTypography>
        <Stack
          direction="row"
          spacing={0}
          justifyContent="center"
          marginTop="5%"
          marginBottom="10%"
          marginLeft="8%"
          marginRight="8%"
        >
          <WsCard
            title="Save time typing, simply parse the JD"
            buttonText="Upload JD"
            description="Autofill the job details form by simply uploading the Job Description"
            onClick={() => {
              amplitude('job_Parse', { userId: loggedInUser.email });
              onChoiceSelection('upload');
            }}
            isButton={true}
            middleComponent={<WsIconJDParse width={96} height={110} />}
          />
          <WsCard
            title="Post Manually"
            buttonText="Continue here"
            description="Choose this option to fill in the job details form manually under 5 mins"
            onClick={() => onChoiceSelection('form')}
            isButton={true}
            cardType={CardVariant.WITH_LIGHT_BG}
            middleComponent={<WsIconJDParse width={96} height={130} />}
          />
          {((loggedInUser?.email && allowedEmails?.includes(loggedInUser?.email)) ||
            workspaceContext.id === 'c982f84c-d9a8-492a-906b-34a2b1831c3e') && (
            <WsCard
              title="Generate Job Description using AI"
              buttonText="Generate JD"
              description="Let AI craft your job descriptions: Accurate, Efficient, and Tailored to Your Needs"
              onClick={() => {
                booleanAmplitudeEvents('Generate_JD_Initiate', 'Generate_JD_Initiate_Button');
                onChoiceSelection('jdGenerator');
              }}
              isButton={true}
              middleComponent={<WsIconJDParse width={96} height={110} />}
            />
          )}
        </Stack>
      </Box>
    </Container>
  );
};

export default JobPostingChoice;
